"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRACKING_SESSION_ID_KEY = void 0;
const uuid_1 = require("uuid");
/**
 * Constant representing the tracking session ID key.
 */
exports.TRACKING_SESSION_ID_KEY = 'numa_tracking_session_id';
/**
 * SessionManager class for managing session IDs.
 */
class SessionManager {
    /**
     * Constructor for SessionManager.
     * @param sessionIdGetter - Function to get the current session ID.
     * @param sessionIdSetter - Function to set the session ID.
     */
    constructor(config) {
        this.config = config;
        this.config = config;
    }
    /**
     * Private method to calculate the expiry date for the session.
     * @returns Date, 30 minutes from now
     */
    getExpiry() {
        const expirationTimeInMinutes = 30;
        const expiry = new Date(new Date().getTime() + expirationTimeInMinutes * 60 * 1000);
        return expiry;
    }
    /**
     * Public method to get the session ID, generating a new one if not present.
     * This method also sets the session id by calling the setter function of the instance
     * @param {number} expirationTimeInMinutes - Number of minutes the returned session ID will be valid for
     * @returns The session ID.
     */
    getRefreshedSessionID() {
        return __awaiter(this, void 0, void 0, function* () {
            let sessionID = yield this.config.getter(exports.TRACKING_SESSION_ID_KEY);
            if (!sessionID) {
                sessionID = (0, uuid_1.v4)();
            }
            const expires = this.getExpiry();
            this.config.setter(exports.TRACKING_SESSION_ID_KEY, sessionID, { expires, domain: this.config.domain });
            return sessionID;
        });
    }
}
exports.default = SessionManager;
//# sourceMappingURL=index.js.map